export default (value) => {

  if (value) {

    const nValue = value.replace('.', '').replace('.', '').replace('.', '').replace('-', '');

    var sum;
    var rest;
    sum = 0;
    if (nValue == "00000000000") return false;

    for (let i = 1; i <= 9; i += 1)
      sum = sum + parseInt(nValue.substring(i - 1, i)) * (11 - i);

    rest = (sum * 10) % 11;

    if ((rest == 10) || (rest == 11)) rest = 0;
    if (rest != parseInt(nValue.substring(9, 10))) return false;

    sum = 0;
    for (let i = 1; i <= 10; i++) sum = sum + parseInt(nValue.substring(i - 1, i)) * (12 - i);
    rest = (sum * 10) % 11;

    if ((rest == 10) || (rest == 11)) rest = 0;
    if (rest != parseInt(nValue.substring(10, 11))) return false;
    return true;

  }

  return false;

};



// WEBPACK FOOTER //
// ./src/components/validators/CPFValidator.js